import React, { useContext, useMemo } from 'react';

type Value = {
  brazeEnabled: boolean;
};

const FeatureFlagContext = React.createContext<Value>({
  brazeEnabled: false,
});

export const FeatureFlagProvider: React.FC<React.PropsWithChildren<Value>> = ({
  children,
  brazeEnabled,
}) => {
  const value = useMemo<Value>(() => ({ brazeEnabled }), [brazeEnabled]);

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export function useFeatureFlag(): Value {
  return useContext(FeatureFlagContext);
}
